import React from 'react';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Typography, Box } from '@mui/material';

export default function PaymentSummary({ title = 'Payment Summary', items = [], total = 0 }) {
    return (
        <Box
            sx={{
                width: '100%',
                borderRadius: 2,
                bgcolor: 'background.paper',
                transition: 'transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
                border: '2px solid transparent',
                '&:hover': {
                    transform: 'translateY(-6px)',
                    borderColor: 'primary.main',
                    boxShadow: 6
                },
                p: 1.25
            }}
        >

            <Paper elevation={0} sx={{ bgcolor: '#673ab7', color: 'white', px: 1.5, py: 0.75, borderRadius: 1 }}>
                <Typography variant="subtitle2"><b>{title}</b></Typography>
            </Paper>

            <TableContainer>
                <Table size="small" aria-label="payment breakdown">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ bgcolor: '#f3f4f6', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Item</TableCell>
                            <TableCell align="right" sx={{ bgcolor: '#f3f4f6', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Unit</TableCell>
                            <TableCell align="right" sx={{ bgcolor: '#f3f4f6', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Qty</TableCell>
                            <TableCell align="right" sx={{ bgcolor: '#f3f4f6', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Amount</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {items.map((it, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{it.label}</TableCell>
                                <TableCell align="right">{(it.unit !== undefined && it.unit !== null) ? `$${Number(it.unit).toFixed(2)}` : '-'}</TableCell>
                                <TableCell align="right">{it.qty !== undefined ? it.qty : (it.quantity ?? '—')}</TableCell>
                                <TableCell align="right">{`$${Number(it.amount || 0).toFixed(2)}`}</TableCell>
                            </TableRow>
                        ))}



                            <TableRow>
                                <TableCell colSpan={3} align="right"><Typography sx={{ fontWeight: 900, fontSize: 16 }}>Total</Typography></TableCell>
                                <TableCell align="right"><Typography sx={{ fontWeight: 900, fontSize: 16 }}>${total.toFixed(2)}</Typography></TableCell>
                            </TableRow>

                    </TableBody>
                </Table>
            </TableContainer>
                <Grid item xs={12}>
                    <Box sx={{
                        p: 1,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: 4,
                        color: 'white',
                        textAlign: 'center',
                        border: '2px solid rgba(255, 255, 255, 0.2)'
                    }}>
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>
                            Total Amount: ${total}
                        </Typography>
                    </Box>
                </Grid>


        </Box>
    );
}